/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_LeadInputs */

const en_mk_tut_lead = /** @type {(inputs: Mk_Tut_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written for someone who has never used a tool like this. Every chapter answers three things: what it is for, what you do, and how you know it worked.`)
};

const id_mk_tut_lead = /** @type {(inputs: Mk_Tut_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditulis untuk orang yang belum pernah memakai alat seperti ini. Tiap bab menjawab tiga hal: apa tujuannya, apa yang harus Anda lakukan, dan bagaimana tahu itu sudah berhasil.`)
};

/**
* | output |
* | --- |
* | "Written for someone who has never used a tool like this. Every chapter answers three things: what it is for, what you do, and how you know it worked." |
*
* @param {Mk_Tut_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_lead = /** @type {((inputs?: Mk_Tut_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_lead(inputs)
	return en_mk_tut_lead(inputs)
});